import $ from 'jquery';
import onUpdateCartCounter from "../../../../../../../plugins/infocity/shop/assets/js/services/update-cart-counter";
import onMiniCartUpdate from "../../../../../../../plugins/infocity/shop/assets/js/services/mini-cart-updater";
import Alert from "../ui/Alert";

$(function () {
    const $formWrapper = $('#app-search-form');

    function getAddedModifications() {
        const result = [];
        $('.app-product-modification-item').each(function () {
            if ($(this).val() > 0) {
                result.push({
                    product_id: $(this).data('product-id'),
                    modification_id: $(this).data('modification-id'),
                    count: $(this).val()
                })
            }
        });
        return result;
    }

    $('.app-custom-add-to-cart').on('click', function (e) {
        e.preventDefault();
        const products = getAddedModifications();
        if (products.length > 0) {
            $.request('onShopAddProductsToCart', {
                method: 'POST',
                loading: $.wn.stripeLoadIndicator,
                data: {
                    products: JSON.stringify(products)
                }
            }).then((response) => {
                onUpdateCartCounter(response);
                onMiniCartUpdate(response);
                $('.app-product-modification-item').val(0);
                $('.app-total-price').html('');
            });
        } else {
            Alert.error('Выберите товар');
        }
    });

    $('.app-customer-type').on('change', function () {
        $('.app-customer-type-form').addClass('d-none');
        $('.ordering-form-type-person').removeClass('active');
        $(this).closest('.ordering-form-type-person').addClass('active');
    });

    $('.app-show-search-form').on('click', function (e) {
        e.preventDefault();
        $formWrapper.toggleClass('d-none');
    });

    $('.app-close-search-form').on('click', function (e) {
        $formWrapper.addClass('d-none');
    });

    $('.app-product-modification-item').on('change', function () {
        const products = getAddedModifications();
        $.request('onFetchPriceType', {
            method: 'POST',
            loading: $.wn.stripeLoadIndicator,
            data: {
                products: JSON.stringify(products)
            }
        }).then((response) => {
            let result = 0;
            $('.app-product-modification-item-wrapper').each(function () {
                const $price = $(this).find('.app-product-modification-item-price');
                const $priceInput = $(this).find('.app-product-modification-item');
                if (response.type === 'default') {
                    $price.html($(this).data('price-sale-formatted') + ' ₽');
                    $priceInput.data('price', $(this).data('price-sale'));
                }
                if (response.type === 'wholesale') {
                    $price.html($(this).data('price-wholesale-formatted') + ' ₽');
                    $priceInput.data('price', $(this).data('price-wholesale'));
                }
                if (response.type === 'wholesale-big') {
                    $price.html($(this).data('price-wholesale-big-formatted') + ' ₽');
                    $priceInput.data('price', $(this).data('price-wholesale-big'));
                }
                result += $priceInput.val() * $priceInput.data('price');
            });
            $('.app-total-price').html('Итого: <span>' + result.toFixed(2) + ' ₽</span>');
        });
    });

    if ($('.submenu-item-level3__button--active').length > 0) {
        const $root = $('.submenu-item-level3__button--active').closest('.accordion-item--level-2');
        $root.find('button:first-child').removeClass('collapsed');
        $root.find('.accordion-collapse--level2').addClass('show');
    }
})
